import React from "react"
import MenuCard from "./subcomponents/MenuCard"
import data from "./subcomponents/data.json"
import { Link } from "react-router-dom"
import Aos from "aos"

export default function Menu() {
    const [filterCount, changeFilterCount] = React.useState(0)
    const [scrollState, changeScrollState] = React.useState(0)
    const [menuFilters, changeMenuFilters] = React.useState("all")

    //All the menu Cards are created
    const menuCards = data.map((bestsellerData, index) => {
        if (bestsellerData.tags.includes(menuFilters)) 
        return (
            <MenuCard 
                header={bestsellerData.header}
                price={bestsellerData.price}
                description={bestsellerData.description}
                image={bestsellerData.image}
                key={index}
                animation={filterCount < 1 ? "fade-up" : ""}
                delay={index % 3 === 0 && window.innerWidth >= 1575 ? "100" : (index + 1) % 3 === 0  && window.innerWidth >= 1575 ? "500" : window.innerWidth >= 1575  ? "300" : index % 2 === 0 && window.innerWidth >= 950 ? "100" : window.innerWidth >= 950 ? "300" : "0"}
            />
        )
    })

    //If a filter is pressed increase filterState to 1
    function filterPressedCount() {
        changeFilterCount(1)
    }

    //Change the filterState to the argument
    function changeFilter(filter) {
        changeMenuFilters(filter)
    }


    //Making all the bestsellers
    let bestsellerArray = []

    data.map(menuData => {
        if (menuData.tags.includes("bestseller")) {
            bestsellerArray.push(1)
        }
    })  

    //Move bestseller scroll left and right
    function changeBestsellersUp() {
        if (scrollState < (bestsellerArray.length - 1) * 1) {
            changeScrollState(prevState => prevState + 1)
        }
        
    }
    function changeBestsellersDown() {
        if (scrollState > 0) {
            changeScrollState(prevState => prevState - 1)
        }
    }


    //Making bestseller cards
    const bestsellerCards = data.map((bestsellerData, index) => {
        if (bestsellerData.tags.includes("bestseller"))
        return (
            <MenuCard 
                header={bestsellerData.header}
                price={bestsellerData.price}
                description={bestsellerData.description}
                image={bestsellerData.image}
                key={index}
                delay={`${index}00`}
                animation="fade-up"
            />
        )
    })


    document.addEventListener('aos:in:menu-in-view', ({ detail }) => {
        setTimeout(filterPressedCount, 1)
    });


    return (
        <main>
            <section className="menu">
                <h1 data-aos="fade-up" data-aos-once="true" data-aos-delay="500">Menu</h1>
            </section>
            <section className="bestsellers menuMainBestsellers">
                <div className="decorationCircleContainer">
                    <div className="decorationCircle"></div>
                </div>
                <h3 data-aos="fade-up" data-aos-once="true" data-aos-delay="300">Our Bestsellers</h3>
                <div className="bestsellerMenu">
                    <div className="bestsellerMenuChange" style={{left: `calc(var(--move-menu) * ${scrollState})`}}>
                        {bestsellerCards}
                    </div>
                </div>
                <div className="bestsellerChange">
                    <div className="bestsellerScrollArrow" onClick={changeBestsellersDown}>
                        <i className="fa-solid fa-angle-left bestsellerScrollArrowLogo"></i>
                    </div>  
                    <div className="bestsellerScroll">
                        <div className="bestsellerScrollColor" style={{width: `calc(${scrollState} * 425% / 4.25 / ${bestsellerArray.length - 1})`}}></div>
                    </div>
                    <div className="bestsellerScrollArrow bestsellerScrollArrowRight" onClick={changeBestsellersUp}>
                        <i className="fa-solid fa-angle-right bestsellerScrollArrowLogo"></i>
                    </div>
                </div>
            </section>
            <section className="fullMenu" data-aos={window.innerWidth < 550 && "fade-up"} data-aos-once="true">
                <div className="menuFilters">
                    <div data-aos={window.innerWidth >= 550 && "fade-up"} data-aos-once="true" data-aos-delay="0">
                        <div className={menuFilters === "all" ? "menuFilter menuFilterActivated" : "menuFilter"} onClick={() => {
                            changeFilter("all") 
                            filterPressedCount()
                        }}>
                            <p>All</p>
                        </div>
                    </div>
                    <div data-aos={window.innerWidth >= 550 && "fade-up"} data-aos-once="true" data-aos-delay="200">
                        <div className={menuFilters === "sushi" ? "menuFilter menuFilterActivated" : "menuFilter"} onClick={() => {
                            changeFilter("sushi")
                            filterPressedCount()
                        }}>
                            <p>Sushi</p>
                        </div>
                    </div>
                    <div data-aos={window.innerWidth >= 550 && "fade-up"} data-aos-once="true" data-aos-delay="400">
                        <div className={menuFilters === "special" ? "menuFilter menuFilterActivated" : "menuFilter"} onClick={() => {
                            changeFilter("special")
                            filterPressedCount()
                        }}>
                            <p>Special</p>
                        </div>
                    </div>
                    <div data-aos={window.innerWidth >= 550 && "fade-up"} data-aos-once="true" data-aos-delay="600">
                        <div className={menuFilters === "appetizers" ? "menuFilter menuFilterActivated" : "menuFilter"} onClick={() => {
                            changeFilter("appetizers") 
                            filterPressedCount()
                        }}>
                            <p>Appetizers</p>
                        </div>
                    </div>
                    <div data-aos={window.innerWidth >= 550 && "fade-up"} data-aos-once="true" data-aos-delay="800">
                        <div className={menuFilters === "baked" ? "menuFilter menuFilterActivated" : "menuFilter"} onClick={() => {
                            changeFilter("baked")
                            filterPressedCount()    
                        }}>
                            <p>Baked</p>
                        </div>
                    </div>
                </div>
                <div className="menuElements" data-aos="fade-in" data-aos-id="menu-in-view" data-aos-once="true">
                    {menuCards}
                </div>
            </section>
        </main>
    )
}